// *******************************************************************************
// Form handling
// *******************************************************************************

const fileCountValidator = () => ({
  validate: (input) => {
    let error = {
      valid: true,
    };
    if (input.element.files) {
      const {
        dataset: { fvNotEmpty___message, maxFiles, maxError },
      } = input.element;
      if (filesToUpload.length > maxFiles) {
        error = {
          valid: false,
          message: maxError,
        };
      }
      if (filesToUpload.length === 0) {
        error = {
          valid: false,
          message: fvNotEmpty___message,
        };
      }
    }
    return error;
  },
});

const fileSizeValidator = () => ({
  validate: (input) => {
    let error = {
      valid: true,
    };

    if (input.element.files) {
      const {
        dataset: { maxSize, sizeError },
      } = input.element;

      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < Array.from(filesToUpload).length; i++) {
        const { file } = Array.from(filesToUpload)[i];

        if (file.size > maxSize) {
          error = {
            valid: false,
            message: sizeError,
          };
          break;
        }
      }
    }

    return error;
  },
});

const fileTypeValidator = () => ({
  validate: (input) => {
    let error = {
      valid: true,
    };

    if (input.element.files) {
      const {
        dataset: { extension, typeError },
      } = input.element;

      const types = extension.split(',');

      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < Array.from(filesToUpload).length; i++) {
        const { file } = Array.from(filesToUpload)[i];
        const fileType = `.${file.name.split('.').pop()}`;

        if (!types.includes(fileType)) {
          error = {
            valid: false,
            message: typeError,
          };
          break;
        }
      }
    }

    return error;
  },
});

const handleForm = (form, formAction) => {
  const fv = FormValidation.formValidation(form, {
    locale: 'sl_SI',
    localization: FormValidation.locales.sl_SI,
    fields: {
    },
    plugins: {
      message: new FormValidation.plugins.Message({
        container: (field, element) => element.closest('.mod-input,.checkbox,.upload-box__main'),
      }),
      declarative: new FormValidation.plugins.Declarative({
        html5Input: true,
      }),
      trigger: new FormValidation.plugins.Trigger(),
      submitButton: new FormValidation.plugins.SubmitButton(),
    },
  })
    .registerValidator('checkFilesSize', fileSizeValidator)
    .registerValidator('checkFilesType', fileTypeValidator);

  if (uploadBox) {
    uploadBox.addEventListener('change', () => fv.validateField('upload[]'));
    uploadBox.addEventListener('fileRemoved', () => fv.validateField('upload[]'));
  }
  fv.on('core.form.valid', () => {
    grecaptcha.ready(async () => {
      const loadingCl = document.querySelector('.loading').classList
      const errorMsg = form.querySelector('.form-error-message');
      try {
        loadingCl.add('is-active');
        const response = await onFormSubmit({
          formData: {
            ...getFormValue(form, fv),
          },
          recaptchaKey: form.querySelector('[data-sitekey]').getAttribute('data-sitekey'),
          recaptchaAction: formAction,
        });
        loadingCl.remove('is-active');
        form.innerHTML = response.data.data.message;
        form.classList.add('show-thankyou');
      } catch (error) {
        loadingCl.remove('is-active');
        if (errorMsg) {
          errorMsg.innerHTML = error.response.data.data.message;
        } else {
          form.innerHTML = error.response.data.data.message;
        }
      }
    });
  });
};

document.addEventListener('DOMContentLoaded', () => {
  ['footerNewsletterForm', 'jobForm'].forEach((id) => {
    const form = document.querySelector(`#${id}`);
    if (form !== null) {
      const formAction = form.querySelector('[data-action]').value;
      handleForm(form, formAction);
    }
  });
});
